// const full_size = {
//   width  : '100%',
//   height : '100%',
// }


// const display = {
//   horizontal  : () => { return { display : 'flex', alignContent:'start', flexDirection: 'row'   , flexWrap: 'nowrap', overflow: 'auto'   } },
//   vertical    : () => { return { display : 'flex', alignContent:'start', flexDirection: 'column', flexWrap: 'nowrap', overflow: 'auto'   } },
//   no_overflow : () => { return { overflow: 'hidden' } },
// }
// const size = {
//   full : () => full_size,
//   set  : (width, height, unit='px') => {
//     return {
//       width  : width  + unit,
//       height : height + unit,
//     }
//   }
// }
// const background = {
//   set     : (color) => { return { background: color } },
//   pd_blue : () => { return { background: '#0886bc' } },
//   red     : () => { return { background: 'red'       } },
// }
// const border = {
//   corner : (thickness, length, color, {corners=[true,true,true,true]} ) => {
//     const color_stop = `#0000 90deg,${color} 0`;
//     const p = `${length} ${length} border-box no-repeat`;
//     return {
//       border       : `${thickness} solid #0000`, /* space for the border */
//       borderRadius : '0.5rem',
//       background   : [
//         corners[0] ? `conic-gradient( from 90deg  at top    ${thickness} left  ${thickness}, ${color_stop} ) 0    0    / ${p}` : 0,
//         corners[1] ? `conic-gradient( from 180deg at top    ${thickness} right ${thickness}, ${color_stop} ) 100% 0    / ${p}` : 0,
//         corners[2] ? `conic-gradient( from -90deg at bottom ${thickness} right ${thickness}, ${color_stop} ) 100% 100% / ${p}` : 0,
//         corners[3] ? `conic-gradient( from 0deg   at bottom ${thickness} left  ${thickness}, ${color_stop} ) 0    100% / ${p}` : 0,
//       ],
//     }
//   },
// }

// export default {
//   display,
//   size,
//   background,
//   border,
// }

const no_overflow = { overflow: 'hidden' };
const group_horizontal = { display: 'flex', alignContent: 'start', flexDirection:'row' }
const group_vertical   = { display: 'flex', alignContent: 'start', flexDirection:'column' }
const fill = { width: '100%', height: '100%' };

const wrap = { flexWrap: 'wrap' };
const wrap_disabled = { flexWrap: 'nowrap' };
const no_gap = { gap: 0 };
const no_shrink = {flexShrink: 0};
const resize_v = { resize: 'vertical' }
const resize_h = { resize: 'horizontal' }
const resize   = { resize: 'both' }
const center_v = { alignItems: 'center' };
const center_h = { justifyItems: 'center' };


//flexDirection: 'column' 
const background = {
  set : (color) => { return {background: color } }
}

const size = {
  set : (width, height=width, unit='px') => {
    return {
      width  : width  + unit,
      height : height + unit,
    }
  }
}


const sizeMax = {
  set : (width, height=width, unit='px') => {
    return {
      maxWidth  : width  + unit,
      maxHeight : height + unit,
    }
  }
}
const sizeMin = {
  set : (width, height=width, unit='px') => {
    return {
      minWidth  : width  + unit,
      minHeight : height + unit,
    }
  }
}

const grid = {
  set: (row_min='2rem', col_min='200px') => {
    return {
      display : 'grid',

      gridTemplateColumns : `repeat( auto-fill, minmax( ${col_min} , 1fr ) )`,
      gridTemplateRows    : `repeat( auto-fill, minmax( ${row_min} , 1fr ) )`,
    }
  }
}

const styles = {
  background,
  center_v,
  center_h,
  size,
  sizeMax,
  sizeMin,
  fill,
  grid,
  group_horizontal,
  group_vertical,
  no_gap,
  no_overflow,
  no_shrink,
  resize,
  resize_h,
  resize_v,
  wrap,
  wrap_disabled,
}

export default styles;